import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders } from '#configuration/tokenHandling/prepareHeaders.ts';

import { rtkAppRetry } from './apiRetry.ts';

export const TAGS = {
    TAGS: 'TAGS',
};

export const apiTagsRoot = createApi({
    tagTypes: Object.keys(TAGS),
    reducerPath: 'apiTags',
    baseQuery: rtkAppRetry(
        fetchBaseQuery({
            baseUrl: import.meta.env.VITE_TAGS_API,
            prepareHeaders,
        })
    ),
    endpoints: () => ({}),
});
